import styled from 'styled-components';
import {
  v2Colors, v2FontFamily, v2ReadableFontFamily, v2Breakpoints,
} from '../../formInputsV2/styles/tokens';

// Standalone copy of InputTable.styles.js for the moto "Versione" picker.
// Starts identical to the auto/autocarro table so it reads the same, but is
// kept separate so moto's version picker can diverge without touching them.
export const VersionTableWrapper = styled.div`
  width: 100%;
  font-family: ${v2FontFamily};

  /* Drop the Bootstrap offset so it lines up with Modello / Marca. */
  .row {
    margin: 0;
  }

  .col-lg-10.offset-lg-1 {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
    margin-left: 0;
    padding: 0;
  }

  .form-input-container {
    padding: 0;
  }

  .form-input-container:hover {
    background-color: transparent;
  }

  /* Mirror the v2 Label component (formInputsV2/styles/common) exactly so
     "Versione" matches "Modello" / "Marca" above it. */
  .f-label {
    display: block;
    width: 100%;
    margin-bottom: 5px;
    padding: 0;
    font-family: ${v2FontFamily};
    font-size: 13.5px;
    font-weight: 700;
    letter-spacing: 0.1px;
    text-align: left;
    color: ${v2Colors.textMuted};
  }

  .version-search {
    width: 100%;
    min-height: 40px;
    margin-bottom: 8px;
    padding: 8px 16px;
    font-family: ${v2ReadableFontFamily};
    font-size: 15px;
    color: ${v2Colors.text};
    background-color: ${v2Colors.inputBackground};
    border: 1.5px solid ${v2Colors.border};
    border-radius: 12px;
    transition: border-color 120ms ease, box-shadow 120ms ease;

    @media (max-width: ${v2Breakpoints.tablet}) {
      font-size: 16px;
    }

    &::placeholder {
      color: ${v2Colors.textFaint};
      font-weight: 600;
    }

    &:hover {
      border-color: ${v2Colors.borderStrong};
    }

    &:focus {
      outline: none;
      border-color: ${v2Colors.primary};
      box-shadow: 0 0 0 3px ${v2Colors.primarySoft};
    }
  }

  .version-empty {
    padding: 16px 12px;
    text-align: center;
    font-size: 13px;
    color: ${v2Colors.textMuted};
  }

  .select-table {
    height: auto;
    max-height: 288px;
    padding: 0 6px 6px;
    border: 1px solid rgba(16, 24, 40, 0.12);
    border-radius: 14px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: ${v2Colors.textFaint} transparent;
    transition: border-color 120ms ease, box-shadow 120ms ease;
  }

  /* Invalid: same red border + soft halo the other v2 controls get, so a
     missing selection reads at a glance and not just as a line of text. */
  .select-table.is-invalid {
    border-width: 1.5px;
    border-color: ${v2Colors.danger};
    box-shadow: 0 0 0 3px rgba(217, 45, 32, 0.12);
  }

  /* Valid: green border + soft halo once a version is picked, matching the
     other v2 inputs' valid state. */
  .select-table.is-valid {
    border-width: 1.5px;
    border-color: ${v2Colors.primary};
    box-shadow: 0 0 0 3px ${v2Colors.primarySoft};
  }

  .select-table::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .select-table::-webkit-scrollbar-track {
    box-shadow: none;
    background: transparent;
  }

  .select-table::-webkit-scrollbar-thumb {
    background: ${v2Colors.textFaint};
    border-radius: 8px;
  }

  /* The TableHeader prop renders as the first .d-flex child of the list —
     kept quiet: a soft rounded bar, sentence case, no hard divider. */
  .select-table > .d-flex {
    position: sticky;
    top: 0;
    z-index: 1;
    margin: 0 -6px 4px;
    padding: 11px 20px;
    background: ${v2Colors.surface};
    border-bottom: 1px solid rgba(16, 24, 40, 0.06);
    border-radius: 13px 13px 0 0;
    font-size: 12px;
    font-weight: 600;
    color: ${v2Colors.textFaint};
  }

  /* Left-align everything — centred table cells are what read as "rigid". */
  .select-table > .d-flex > div,
  div.select-table-item .col-6 {
    text-align: left;
  }

  .select-table-item {
    margin: 2px 0;
    padding: 12px 14px;
    border-radius: 10px;
    font-family: ${v2FontFamily};
    font-size: 13px;
    font-weight: 500;
    color: ${v2Colors.text};
    transition: background-color 160ms ease, color 160ms ease;
  }

  .select-table-item:nth-child(even),
  .select-table-item:nth-child(odd) {
    background-color: transparent;
  }

  div.select-table-item:hover {
    background-color: ${v2Colors.surface};
  }

  div.select-table-item.selected {
    background-color: ${v2Colors.primarySoft};
    color: ${v2Colors.primary};
    font-weight: 600;
  }

  .d-md-none.select-table-item span {
    font-size: 12.5px;
  }

  .d-md-none.select-table-item span:first-child {
    color: ${v2Colors.textMuted};
    font-weight: 500;
  }

  .general-input-error {
    margin-top: 6px;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.3;
    color: ${v2Colors.danger};
  }
`;
